// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"9a6b3686","58":"b391382d","156":"262291b3","194":"a9eca650","372":"7f55f966","480":"41241286","493":"a2f7a7da","602":"dff6634f","818":"d4dbbd52"}[chunkId] + ".chunk.js";
};